import { useEffect, useState } from 'react';
import Input from '../../components/Input';
import Card from '../../components/Card';
import Stack from '../../components/Stack';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Button from '../../components/Button'


import { createCompetition, fetchAdminCompetition, updateAdminCompetition } from '../../api/admin/api';
import Checkbox from '../../components/Checkbox';
import FlashMessage from '../../components/FlashMessage';
import { set } from 'date-fns';

export default function CreateCompetitionForm() {
  const [name, setName] = useState('');
  const [teamSize, setTeamSize] = useState('');
  const [rookieCount, setRookieCount] = useState('');
  const [veteranCount, setVeteranCount] = useState('');
  const [includeAddress, setIncludeAddress] = useState(false);
  const [officeRestriction, setOfficeRestriction] = useState(false);
  const [partnerRestriction, setPartnerRestriction] = useState(false);
  const [divisionRestriction, setDivisionRestriction] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [status, setStatus] = useState(null);
  const [vivintCompetitionId, setVivintCompetitionId] = useState('');
  const [eventParticipationLimit, setEventParticipationLimit] = useState(false);
  const [teamNamePrefixType, setTeamNamePrefixType] = useState('office_name');
  const [type, setType] = useState('success')
  const navigate = useNavigate();
  const { editing, id } = useParams()
  const [isEditing, setIsEditing] = useState(editing === 'true');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);

    const payload = {
      name,
      team_size: teamSize,
      rookie_count: rookieCount,
      veteran_count: veteranCount,
      include_address: includeAddress,
      event_participation_limit: eventParticipationLimit,
      office_restriction: officeRestriction,
      partner_restriction: partnerRestriction,
      division_restriction: divisionRestriction,
      is_active: isActive,
      id: id,
      vivint_competition_id: vivintCompetitionId,
      team_name_prefix_type: teamNamePrefixType
    };

    let res;
    try {
      if(!isEditing ) {
        res = await createCompetition(payload);
      } else {
        res = await updateAdminCompetition(payload)
      }

      if (res && !isEditing) {
        setStatus('Created successfully');
        setType('success')
        setTimeout(() => navigate('/admin/competitions'), 1000);
      } else if(res && isEditing) {
        setStatus('Updated successfully');
        setType('success')
        setTimeout(() => navigate(`/admin/competitions/${id}`), 1000);
      } else {
        setStatus(`Failed to create`);
        setType('failure')
      }
    } catch (error) {
      setStatus(`Error: ${error.message}`);
      setType('failure')
    } finally {
      setTimeout(() => setDisabled(false), 2000);
    }
  };

  const resetForm = () => {
    setName('');
    setTeamSize('');
    setRookieCount('');
    setVeteranCount('');
    setVivintCompetitionId('')
    setIncludeAddress(false);
    setOfficeRestriction(false);
    setPartnerRestriction(false);
    setDivisionRestriction(false);
    setIsActive(true);
    setEventParticipationLimit(false);
    setTeamNamePrefixType('office_name');
  };

  useEffect(() => {
    console.log('editing', editing)
    if(isEditing) {
      setDisabled(true);

      fetchAdminCompetition(id)
        .then(res => {
          const {
            name,
            team_size,
            // setter_count,
            rookie_count,
            veteran_count,
            // division_split,
            // direct_to_home,
            include_address,
            event_participation_limit,
            // quarterly_competition,
            office_restriction,
            partner_restriction,
            division_restriction,
            is_active,
            vivint_competition_id,
            team_name_prefix_type
          } = res

          setName(name)
          setTeamSize(team_size)
          // setSetterCount(setter_count)
          setRookieCount(rookie_count)
          setVeteranCount(veteran_count)
          // setDivisionSplit(division_split)
          // setDirectToHome(direct_to_home)
          setIncludeAddress(include_address)
          // setQuarterlyCompetition(quarterly_competition)
          setOfficeRestriction(office_restriction)
          setPartnerRestriction(partner_restriction)
          setDivisionRestriction(division_restriction)
          setIsActive(is_active)
          setVivintCompetitionId(vivint_competition_id)
          setEventParticipationLimit(event_participation_limit)
          setTeamNamePrefixType(team_name_prefix_type || 'office_name')
        })
        .catch((err) => {
          setStatus(`Failed to Fetch Competition. ${err.message}`)
        })
        .finally(() => {
          setDisabled(false);
        });
    } else {
      resetForm();
    }
  }, [])

  return (
    <Card>
      <FlashMessage
        message={status}
        type={type}
        onClose={() => {console.log('do nothing')}}
      />
      <Stack align='start' justify='center' className='gap-4'>
        <Stack width="full" align='start' justify='center' className='py-6 gap-2 border-b'>
          <Header size='xl'>{isEditing ? 'Edit Competition' : 'Create New Competition'}</Header>
          <p className='text-sm'>Select all competition parameters</p>
        </Stack>

        <form className="w-full flex flex-col items-center gap-8" onSubmit={handleSubmit}>
          <Stack width='full' justify='start' align='start' className='gap-4'>
            {[
              { value: name, placeholder: 'Competition Name', type: 'text', setter: setName },
              { value: vivintCompetitionId, placeholder: 'Vivint Competition ID', type: 'number', setter: setVivintCompetitionId },
              { value: teamSize, placeholder: 'Team Size', type: 'number', setter: setTeamSize },
              { value: rookieCount, placeholder: 'Rookie Count', type: 'number', setter: setRookieCount },
              { value: veteranCount, placeholder: 'Veteran Count', type: 'number', setter: setVeteranCount },
            ].map(({ value, placeholder, type, setter }) => (
              <Input
                key={placeholder}
                value={value}
                placeholder={placeholder}
                type={type}
                onChange={(e) => setter(e.target.value)}
              />
            ))}

            <div className='text-black flex flex-col items-start justify-start w-full gap-1'>
              <p className="px-2 text-xs text-gray-400">Team Name Prefix</p>
              <select
                className="p-2 w-full text-black border border-gray-300 rounded-md focus:border-yellow-300 focus:outline-none focus:ring-0"
                value={teamNamePrefixType}
                onChange={(e) => setTeamNamePrefixType(e.target.value)}
              >
                <option value="office_name">Office Name</option>
                <option value="rep_name">Rep Name</option>
                <option value="employee_id">Employee ID</option>
              </select>
            </div>

            <div className="w-auto max-w-full grid grid-cols-2 gap-y-6 gap-x-28 pt-4 text-sm text-black">
              {[
                { label: 'Include Address', checked: includeAddress, setter: setIncludeAddress },
                { label: 'Office Restriction', checked: officeRestriction, setter: setOfficeRestriction },
                { label: 'Partner Restriction', checked: partnerRestriction, setter: setPartnerRestriction },
                { label: 'Division Restriction', checked: divisionRestriction, setter: setDivisionRestriction },
                { label: 'Is Active', checked: isActive, setter: setIsActive },
                { label: 'Event Participation Limit', checked: eventParticipationLimit, setter: setEventParticipationLimit },
              ].map(({ label, checked, setter }) => (
                <Checkbox
                  key={label}
                  label={label}
                  value={checked}
                  handleClick={setter}
                />
              ))}
            </div>
          </Stack>

          <Stack width='full' direction='row' justify='end' align='center'>
            <Button
              color={disabled ? 'gray' : 'yellow'}
              className='w-auto max-w-max py-2 px-14'
              type="submit"
              disabled={disabled}
            >
              {isEditing ? 'Update Competition' : 'Create Competition'}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Card>
  );
}
